import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import ScrollProgressCar from './components/feature/ScrollProgressCar';
import CTABanner from './components/feature/CTABanner';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <CTABanner />
        <ScrollProgressCar />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
